// extracted by mini-css-extract-plugin
export default {"hint":"PermissionPicker_hint__M34QH","subAuthorities":"PermissionPicker_subAuthorities__Oo0Ey"};